export enum EFFECT_TYPE {
    ACTION = 'action',
    SEQUENCE = 'sequence',
    PARALLEL = 'parallel'
}
